export enum Role {
  OPERATOR = 'Operator',
  DRCD = 'DRCD',
  ADMIN = 'Admin',
}

export const isRole = (object: unknown): object is Role =>
  typeof object === 'string' && Object.values(Role).includes(object as Role);

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  isActive: boolean;
  operatorId?: string;
}

export interface UserOperator {
  userId: string;
  operatorId: string;
  operatorName: string;
  operatorEmail: string;
}

export interface NewUser {
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  operatorId?: string;
}

export const isUser = (object: unknown): object is User => {
  if (typeof object !== 'object') {
    return false;
  }
  if (!object) {
    return false;
  }
  if (Array.isArray(object)) {
    return false;
  }
  const recordObject = object as Record<string, unknown>;

  return (
    typeof recordObject.email === 'string' &&
    typeof recordObject.firstName === 'string' &&
    typeof recordObject.lastName === 'string' &&
    isRole(recordObject.role)
  );
};

export type ChangeUserStatusPayload = Pick<User, 'isActive' | 'id'>;
